/** Denetlenen türler, kuyruk önceliği sırasıyla (önce hidrotest ve NDT; K19). Dönüşüm işinin `belge_turu` değeri de budur. */
export const DENETIM_TURLERI = ["hidrotest", "ndt", "weldmap", "pwht"];
export const denetimTuruMu = (x) => typeof x === "string" && DENETIM_TURLERI.includes(x);
/** Türün ekran adı (sözlükte). */
export const DENETIM_TUR_ADI = { hidrotest: "Hydrotest certificate", ndt: "NDT report", weldmap: "Weld map", pwht: "PWHT chart" };
/** Olay kaydında nesne tipi (nesneId = belge_denetimi.id). */
export const DENETIM_OLAY_NESNESI = "belge_denetimi";
/** Denetim kaydının kodu ("AUD-1B8E5A37"; hidrotestKodu emsali). */
export const denetimKodu = (id) => `AUD-${id.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** Bir koşuda en çok bu kadar belge için kayıt açılır (sıraya giren + bir kez okunan + bekleyen). */
export const DENETIM_KOSU_SINIRI = 100;
/** Kuyrukta aynı anda en çok bu kadar denetim işi (sırada ya da dönüştürülüyor). */
export const DENETIM_KUYRUK_SINIRI = 300;
/** Denetim listesinin sayfa boyu. */
export const DENETIM_SAYFA = 50;
/** Görünen durum (J19). */
export const DENETIM_DURUMLARI = ["okundu", "okunuyor", "sirada", "hata", "bekliyor", "okunmadi"];
export const DENETIM_DURUM_ADI = {
    okundu: "Read", okunuyor: "Reading", sirada: "In the queue", hata: "Could not read", bekliyor: "Waits for the same file", okunmadi: "Not read",
};
/**
 * Yerin tekil anahtarı: "ht:R107:Choke" | "ht:R107:Choke:ret" | "hat_ndt:R107:Choke" | "adim_raporu:<tamirId>:<adim>" | "weldmap:<tamirId>" |
 * "pwht:<tamirId>:<adim>". Denetlenmeyen yer türünde null.
 */
export function denetimYerAnahtari(h) {
    switch (h.tur) {
        case "ht": return `ht:${h.rn}:${h.hat}${h.ret ? ":ret" : ""}`;
        case "hat_ndt": return `hat_ndt:${h.rn}:${h.hat}`;
        case "adim_raporu": return `adim_raporu:${h.tamirId}:${h.adim}`;
        case "weldmap": return `weldmap:${h.tamirId}`;
        case "pwht": return `pwht:${h.tamirId}:${h.adim}`;
        default: return null;
    }
}
/** Yerin gelen türü; denetlenmeyen yer türünde null. */
export function denetimGelenTuru(h) {
    return h.tur === "ht" || h.tur === "hat_ndt" || h.tur === "adim_raporu" || h.tur === "weldmap" || h.tur === "pwht" ? h.tur : null;
}
/** Yer türü denetim türüne uyuyor mu: ht → hidrotest; hat_ndt ve adim_raporu → ndt; weldmap → weldmap; pwht → pwht. */
export function denetimYeriUyar(tur, h) {
    switch (tur) {
        case "hidrotest": return h.tur === "ht";
        case "ndt": return h.tur === "hat_ndt" || h.tur === "adim_raporu";
        case "weldmap": return h.tur === "weldmap";
        case "pwht": return h.tur === "pwht";
    }
}
/** J19: görünen durum. `kardesAktif`: aynı baytlı (ya da aynı özetli) başka bir kaydın işi sırada ya da dönüştürülüyor. */
export function denetimDurumu(k) {
    if (k.okumaVar)
        return "okundu";
    if (k.is === "donusturuluyor")
        return "okunuyor";
    if (k.is === "sirada")
        return "sirada";
    if (k.is === "hata")
        return "hata";
    return k.kardesAktif ? "bekliyor" : "okunmadi";
}
export function denetimSinifi(a) {
    const k = a.kayit;
    if (k && (k.okumaVar || k.is === "sirada" || k.is === "donusturuluyor" || (k.is === null && a.kardesAktif)))
        return "atlandi";
    if (!k && a.documentsOkundu)
        return "documents";
    if (a.kopyaVar)
        return "kopya";
    if (a.kardesAktif)
        return "bekleyen";
    return "siraya";
}
const GUN = /^\d{4}-\d{2}-\d{2}$/;
/** Tarih süzgeci: YYYY-MM-DD, başlangıç bitişten sonra olamaz; boş = sınırsız. Hata cümlesi (sözlükte) ya da null. */
export function denetimTarihHatasi(bas, son) {
    const b = bas?.trim() || null;
    const s = son?.trim() || null;
    const gecerli = (x) => GUN.test(x) && !Number.isNaN(Date.parse(`${x}T00:00:00Z`)) && new Date(`${x}T00:00:00Z`).toISOString().slice(0, 10) === x;
    if ((b && !gecerli(b)) || (s && !gecerli(s)))
        return "Dates: write YYYY-MM-DD.";
    if (b && s && b > s)
        return "Dates: \"from\" must not be after \"to\".";
    return null;
}
//# sourceMappingURL=belge-denetimi.js.map